import type { PostHogConfig } from 'posthog-js'
import { markInternalUser } from './internalUser'
import { recordSiteReferral } from './siteReferral'
import { languageSuperProperties } from '../i18n/current'

export const {
  NODE_ENV,
  REACT_APP_MAAYOT_API_DEV,
  REACT_APP_MAAYOT_API_PROD,
  REACT_APP_PUBLIC_POSTHOG_KEY,
  REACT_APP_GTM_ID,
  REACT_APP_VIDEO_SDK_API_KEY,
  REACT_APP_VIDEO_SDK_API_SECRET,
  REACT_APP_SUPPORT_EMAIL,
  REACT_APP_HACK_CHINESE_APP_KEY,
} = process.env

// Optional per-branch API override, set by amplify.yml on preview branches only
// (see REACT_APP_API_BASE_URL_PREVIEW). When unset or empty this is a no-op and
// the original NODE_ENV-based selection below applies unchanged, so `main` and
// `prod` builds behave exactly as before.
const API_OVERRIDE = process.env.REACT_APP_API_BASE_URL

const MAAYOT_API =
  API_OVERRIDE || (NODE_ENV === 'production' ? REACT_APP_MAAYOT_API_PROD : REACT_APP_MAAYOT_API_DEV)
export const REACT_APP_AUTH_API_DEV = (API_OVERRIDE || process.env.REACT_APP_MAAYOT_API_DEV)?.replace(
  'v1',
  'v2',
)
export const MEETING_BASE_URL = 'https://api.videosdk.live/v2'
export const SUPPORT_EMAIL = REACT_APP_SUPPORT_EMAIL

export const headers = {
  'Content-Type': 'application/json',
}
export const postHogOptions: Partial<PostHogConfig> = {
  api_host: 'https://jspr.maayot.com',
  defaults: '2026-01-30',
  // Tag team browsers as soon as PostHog is ready and before any event leaves,
  // so internal traffic is excluded from the very first anonymous pageview.
  // `loaded` is the earliest safe point: register() writes through PostHog's
  // persistence layer, which does not exist until init has run. The www
  // referral is attached here for the same reason.
  loaded: (posthog) => {
    markInternalUser(posthog)
    recordSiteReferral(posthog)
    // Interface language on every event, from the first page view (i18n/index.ts keeps it current).
    posthog.register(languageSuperProperties())
  },
}

export default MAAYOT_API
